import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { nav, assets } from "../mock";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0c0b08]/90 backdrop-blur-md border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group" aria-label="Melano International home">
          <img src={assets.monogram} alt="Melano International" className="h-10 w-auto" />
          <span className="font-display text-foreground text-lg tracking-[0.28em] uppercase hidden sm:block">
            Melano
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {nav.map((item) => {
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`link-underline font-display uppercase text-sm tracking-[0.2em] transition-colors ${
                  active ? "text-gold" : "text-foreground/85 hover:text-gold"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <button
          className="md:hidden text-foreground p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-400 bg-[#0c0b08]/97 backdrop-blur-md ${
          open ? "max-h-72 border-b border-border" : "max-h-0"
        }`}
      >
        <nav className="container-x py-6 flex flex-col gap-5">
          {nav.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="font-display uppercase text-base tracking-[0.2em] text-foreground/90 hover:text-gold"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
